import { registerComponent } from "helpers";

registerComponent(
  "wyatt-related-collections",
  class WyattRelatedCollections extends HTMLElement {
    constructor() {
      super();

      this.list = this.querySelector(".related-collections__list");
      this.activeItem = this.querySelector(
        ".related-collections__item--active"
      );
      this.scrollToActiveItem();
    }

    scrollToActiveItem(behavior = "instant") {
      const listWidth = this.list.offsetWidth;
      const itemWidth = this.activeItem.offsetWidth;
      const itemOffset = this.activeItem.offsetLeft;
      const shouldScroll = itemOffset + itemWidth > listWidth;

      if (shouldScroll) {
        this.list.scrollTo({
          top: 0,
          left: itemOffset,
          behavior,
        });
      }

      this.setAttribute("ready", true);
    }
  }
);
